import React from 'react';
import './DiagnosticBanner.css';

const DiagnosticBanner = () => {
  return (
    <section className="diagnostic-banner">
      <div className="diagnostic-container">
        <div className="diagnostic-content">
          <div className="diagnostic-text">
            <div className="diagnostic-title-wrapper">
              <h2 className="diagnostic-title">AUDIT GRATUIT DE VOTRE STRATÉGIE COMMERCIALE</h2>
              <div className="diagnostic-description">
                <p className="diagnostic-main-text">
                  Nos consultants analysent votre approche actuelle et identifient les axes prioritaires 
                  de développement pour votre entreprise.
                </p>
              </div>
            </div>
            
            <div className="diagnostic-action">
              <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
                <button className="diagnostic-button">RÉSERVER MON DIAGNOSTIC</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiagnosticBanner; 